import { render, staticRenderFns } from "./contract-agent-add.vue?vue&type=template&id=0b6da454&scoped=true"
import script from "./contract-agent-add.vue?vue&type=script&lang=js"
export * from "./contract-agent-add.vue?vue&type=script&lang=js"
import style0 from "./contract-agent-add.vue?vue&type=style&index=0&id=0b6da454&prod&lang=css"
import style1 from "./contract-agent-add.vue?vue&type=style&index=1&id=0b6da454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6da454",
  null
  
)

export default component.exports